export const handleMultipleDownload = (blob: Blob): void => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "certificates.zip";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
